import {observer} from "mobx-react";
import * as React from "react";
import {TableViewV5} from "../../../abstract/TableViewV5";
import {XyiconFeature} from "../../../../../generated/api/base";
import type {UserGroup} from "../../../../../data/models/UserGroup";
import type {IActionBarItem} from "../../../abstract/ModuleViewV5";
import DeleteIcon from "../../../icons/delete.svg?react";
import {Functions} from "../../../../../utils/function/Functions";
import {UserGroupDetailsContentV5} from "./UserGroupDetailsContentV5";
import {CreateUserGroupPanelV5} from "./CreateUserGroupPanelV5";

@observer
export class UserGroupsViewV5 extends React.Component {
	private _headers = [
		{
			id: "name",
			title: "Group Name",
		},
		{
			id: "userIds",
			title: "Number of Users",
		},
		{
			id: "lastModifiedAt",
			title: "Last Updated",
		},
		{
			id: "lastModifiedBy",
			title: "Updated By",
		},
	];

	private canDeleteUserGroup = (users: UserGroup[]) => {
		if (users.length < 1) {
			return false;
		}

		const areThereAnySystemItemsInSelectedItems = users.some((item) => (item as unknown as UserGroup).isSystem);

		if (areThereAnySystemItemsInSelectedItems) {
			return false;
		}

		return true;
	};

	public override render() {
		const getActionBar = () => {
			const result: IActionBarItem<UserGroup>[] = [
				{
					id: "delete",
					title: "Delete Report",
					label: "Delete",
					IconComponent: DeleteIcon,
					isVisible: Functions.returnTrue,
					isEnabled: this.canDeleteUserGroup,
				},
			];

			return result;
		};

		return (
			<TableViewV5
				feature={XyiconFeature.UserGroup}
				headers={this._headers}
				create={(onCreated, onCancel, creating) => (
					<CreateUserGroupPanelV5
						onCreated={onCreated}
						creating={creating}
					/>
				)}
				details={(selected: UserGroup[]) => <UserGroupDetailsContentV5 userGroups={selected} />}
				actionBar={getActionBar()}
			/>
		);
	}
}
